import { Button, Modal } from '../../components/ui'
import { useNavigate } from 'react-router-dom'
import type { NotificationItem } from './types'

interface NotificationDetailsModalProps {
  item: NotificationItem | null
  onClose: () => void
}

const actorName = (item: NotificationItem): string | undefined =>
  item.actor_name
  || item.actor?.user_name
  || item.actor?.name
  || item.event?.actor_name
  || item.event?.actor?.user_name
  || item.event?.actor?.name
  || undefined

function formatCreatedAt(value: string): string {
  const date = new Date(value)
  if (!Number.isFinite(date.getTime())) return value
  return new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date)
}

function safeInternalAction(value: unknown): string | null {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) return null
  return [...value].every((character) => character.charCodeAt(0) >= 32 && character.charCodeAt(0) !== 127)
    ? value
    : null
}

export function NotificationDetailsModal({ item, onClose }: NotificationDetailsModalProps) {
  const navigate = useNavigate()
  if (!item) return null
  const actor = actorName(item)
  const actionUrl = safeInternalAction(item.action_url)

  return (
    <Modal
      isOpen
      onClose={onClose}
      title={item.title}
      subtitle={formatCreatedAt(item.created_at)}
      size="sm"
      footer={<div className="flex items-center justify-end gap-2">
        {actionUrl && <Button onClick={() => { onClose(); navigate(actionUrl) }}>{item.action_label || 'Открыть'}</Button>}
        <Button variant="secondary" onClick={onClose}>ОК</Button>
      </div>}
    >
      <div className="space-y-4">
        {item.body && (
          <p className="whitespace-pre-wrap text-sm leading-6 text-gray-700 dark:text-zinc-200">
            {item.body}
          </p>
        )}
        {actor && (
          <div className="border-t border-gray-100 pt-3 text-xs text-gray-500 dark:border-zinc-800 dark:text-zinc-400">
            Автор: {actor}
          </div>
        )}
      </div>
    </Modal>
  )
}
